/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";

import {
  Box,
  List,
  ListSubheader,
  ListItem,
  Stack,
  useMediaQuery,
  Button,
  ListItemButton,
  Tooltip,
} from "@mui/material";

import { formatCurrency } from "@brazilian-utils/brazilian-utils";

import { Form } from "@unform/web";
import { MdSearch } from "react-icons/md";
import CachedIcon from "@mui/icons-material/Cached";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { FormHandles } from "@unform/core";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { ItemText } from "../../../components/itemText";
import theme from "../../../theme";
import HeaderComp from "../../../components/header";
import { Container, TabelaDiv } from "./styles";
import Input from "../../../components/Input";
import Select from "../../../components/Select";
import ButtonStyled from "../../../components/Button";
import { ArrayFilters } from "../../../interfaces/filterSearch";
import { useToast } from "../../../hooks/toast";
import TicketingService from "../../../services/ticketing";
import { RechargesResponse } from "../../../interfaces/recharge";
import { BannerTable } from "./Components/BannerTable";
import { ProfileData } from "../../MeuPerfil";
import { useAuth } from "../../../hooks/auth";
import AccountsService from "../../../services/accounts";
import Loader from "../../../components/Loader";
import ModalVerificar from "./ModalVerificar";
import CoreService from "../../../services/core";
import ModalExcluir from "./ModalExcluir";

interface DadosFiltros {
  value: string;
  label: string;
}

const AppVersion: React.FC = () => {
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const servicesacc = { AccountsService: new AccountsService() };
  const services = { coreServices: new CoreService() };

  const pageSize = useMediaQuery("(max-width:1600px)");

  const [alertaOn, setAlertaOn] = React.useState<boolean>(false);
  const [excluirOn, setExcluirOn] = React.useState<boolean>(false);
  const [pedidoId, setPedidoId] = React.useState("");
  const [pedidoVersion, setPedidoVersion] = React.useState("");
  const [externalPedido, setExternalPedido] = React.useState("");
  const [pedidoVerificado, setPedidoVerificado] =
    React.useState<boolean>(false);
  const [pedidoAlterado, setPedidoAlterado] = React.useState<boolean>(false);

  const [dadosBusca, setDadosBusca] = React.useState("");

  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [lastPage, setLastPage] = useState<number>(0);
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{}],
  });
  const [allAppVersion, setAllAppVersion] = useState<any>();

  const formRef = React.useRef<FormHandles>(null);

  const recebeId = (idalerta: any, isverificado: boolean, external: any) => {
    setPedidoVerificado(isverificado);
    setPedidoId(idalerta);
    setExternalPedido(external);
    setAlertaOn(true);
  };

  const DeletaId = (idalerta: any, version: any) => {
    setPedidoId(idalerta);
    setPedidoVersion(version);
    setExcluirOn(true);
  };

  const getList = useCallback(async () => {
    setLoading(true);
    const response = await services.coreServices.getAppVersion();
    setAllAppVersion(response?.data);
    setTotalRows(response.data.count);
    const pages = response.data.count / 40;
    setLastPage(Math.ceil(pages));
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, [filters, dadosBusca]);

  const filteredFilters = filters.filters.filter(
    (item) => !item.hasOwnProperty("page")
  );

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setPage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters]
  );

  useEffect(() => {
    getList();
  }, [page, filters]);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      localStorage.removeItem("RecargaStatus");

      // Exemplo: salvar dados no localStorage antes de sair
      localStorage.setItem("lastVisit", new Date().toISOString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remover o listener quando o componente é desmontado
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {}, [dadosBusca, filters, filteredFilters, dadosBusca]);

  useEffect(() => {
    if (pedidoAlterado) {
      getList();
      setPedidoAlterado(false);
    }
  }, [pedidoAlterado]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <HeaderComp filtroNaparece={true} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              margin: 0,
            }}
          >
            {/* {!pageSize && <NavBar />} */}
            <Box sx={{ display: "flex", flexGrow: 1 }}>
              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                <Container>
                  <List
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: 2,
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "RGB(248, 248, 248)",
                        borderRadius: 4,
                        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                        overflowX: "auto",
                        display: "grid",
                      }}
                    >
                      <Stack
                        sx={{
                          zIndex: 0,
                        }}
                      >
                        <ListSubheader
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            fontWeight: "bold",
                            marginTop: "10px",
                            backgroundColor: "RGB(248, 248, 248)",
                          }}
                        >
                          <Box>
                            <ItemText
                              primary="Versões do App"
                              hideSecondary
                              primarySx={{
                                color: theme.palette.secondary.main,
                                fontSize: pageSize ? "30px" : "20px",
                                fontWeight: "bold",
                              }}
                            />
                          </Box>
                          <Stack
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "right",
                              alignContent: "center",
                            }}
                          >
                            <Link to="/appversionnew">
                              <h3 className="addBanner">
                                Nova Versão
                                <AddIcon className="iconNew" />
                              </h3>
                            </Link>
                          </Stack>
                        </ListSubheader>
                      </Stack>
                      {!loading && (
                        <TabelaDiv className="Tabela">
                          <BannerTable
                            data={allAppVersion.results}
                            columns={[
                              {
                                name: <div>Ação</div>,
                                selector: "action",
                                cell: ({
                                  id,
                                  needs_to_be_verified,
                                  external_code,
                                  version,
                                }: any) => (
                                  <Stack
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-evenly",
                                    }}
                                  >
                                    <Link
                                      to={`/app-version/${id}`}
                                      className="custom-link"
                                    >
                                      <Tooltip title="Visualizar Banner">
                                        <VisibilityIcon className="iconView" />
                                      </Tooltip>
                                    </Link>
                                    <Tooltip
                                      title="Deletar Banner?"
                                      onClick={() => DeletaId(id, version)}
                                    >
                                      <DeleteIcon className="iconDelete" />
                                    </Tooltip>
                                  </Stack>
                                ),
                              },
                              {
                                name: <div>ID</div>,
                                selector: "id",
                                cell: ({ id }: any) => (
                                  <div className="specifitcell">{id}</div>
                                ),
                              },
                              {
                                name: <div>Versão</div>,
                                selector: "version",
                                cell: ({ version }: any) => (
                                  <div className="specifitcell">{version}</div>
                                ),
                              },
                              {
                                name: <div>Status</div>,
                                selector: "is_active",
                                cell: ({ is_active }: any) => (
                                  <div className="specifitcell">
                                    {is_active === true ? (
                                      <strong
                                        style={{ color: "var(--purple)" }}
                                      >
                                        Ativo
                                      </strong>
                                    ) : (
                                      <strong
                                        style={{ color: "var(--orange)" }}
                                      >
                                        Inativo
                                      </strong>
                                    )}
                                  </div>
                                ),
                              },
                              {
                                name: <div>Data de Lançamento</div>,
                                selector: "release_date",
                                cell: ({ release_date }: any) => (
                                  <div className="specifitcell">
                                    {release_date}
                                  </div>
                                ),
                              },
                              {
                                name: <div>Nota de versão</div>,
                                selector: "release_note",
                                cell: ({ release_note }: any) => (
                                  <div className="specifitcell">
                                    {release_note}
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </TabelaDiv>
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 2,
                          marginBottom: 2,
                          fontWeight: "bold",
                        }}
                      >
                        <Button
                          disabled={allAppVersion?.previous === null}
                          onClick={() => handleChangePerPage(1)}
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Primeira Página
                        </Button>
                        <Button
                          disabled={allAppVersion?.previous === null}
                          onClick={() => handleChangePerPage(page - 1)}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Anterior
                        </Button>
                        <Box
                          sx={{ margin: 2 }}
                        >{`Página ${page} de ${lastPage}`}</Box>
                        <Button
                          disabled={allAppVersion?.next === null}
                          onClick={() => handleChangePerPage(page + 1)}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Próxima
                        </Button>
                        <Button
                          disabled={allAppVersion?.next === null}
                          onClick={() => handleChangePerPage(lastPage)}
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Última Página
                        </Button>
                      </Box>
                    </Box>
                  </List>
                </Container>
              </Box>
            </Box>
          </Box>
          {alertaOn && (
            <ModalVerificar
              open={alertaOn}
              handleClose={() => setAlertaOn(false)}
              id={pedidoId}
              verificado={pedidoVerificado}
              external={externalPedido}
              pedidoAlterado={setPedidoAlterado}
            />
          )}
          {excluirOn && (
            <ModalExcluir
              open={excluirOn}
              handleClose={() => setExcluirOn(false)}
              id={pedidoId}
              version={pedidoVersion}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default AppVersion;
